import type { PollContentObjectDetail, PollContentObjectList } from 'models';
import { useCallback, useMemo } from 'react';
import { useConfirmDelete } from '../../../hooks';
import { useDeletePollContentObjectMutation } from '../../../queries';

export const useDeletePollConfirmModal = () => {
  const { mutateAsync: deletePoll } = useDeletePollContentObjectMutation();
  const { confirm, contextHolder } = useConfirmDelete();

  const confirmDelete = useCallback(
    ({
      item,
      onSuccess,
      title,
    }: {
      item: PollContentObjectDetail | PollContentObjectList;
      onSuccess: () => void;
      title: string;
    }) => {
      confirm({
        async onOk() {
          await deletePoll(
            { contentObject: item },
            {
              onSuccess,
            },
          );
        },
        title,
      });
    },
    [confirm, deletePoll],
  );

  return useMemo(
    () => ({
      confirm: confirmDelete,
      contextHolder,
    }),
    [confirmDelete, contextHolder],
  );
};
